import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import type { IconName } from '@/components/common/Icon';

export interface ClientNavigationItem {
  id: string;
  labelKey: string;
  iconName: IconName;
  route: string;
  showOnBottomBar: boolean;
  requiredModule?: string;
  unreadBadge?: boolean;
}

export const CLIENT_NAVIGATION_ITEMS: ClientNavigationItem[] = [
  {
    id: 'home',
    labelKey: 'portal.nav.home',
    iconName: 'Home',
    route: APPLICATION_ROUTES.clientPortal,
    showOnBottomBar: true,
  },
  {
    id: 'pets',
    labelKey: 'portal.nav.pets',
    iconName: 'PawPrint',
    route: APPLICATION_ROUTES.clientPortalPets,
    showOnBottomBar: true,
  },
  {
    id: 'visits',
    labelKey: 'portal.nav.visits',
    iconName: 'Calendar',
    route: APPLICATION_ROUTES.clientPortalVisits,
    showOnBottomBar: true,
  },
  {
    id: 'messages',
    labelKey: 'portal.nav.messages',
    iconName: 'MessageCircle',
    route: APPLICATION_ROUTES.clientPortalChat,
    requiredModule: 'chat',
    unreadBadge: true,
    showOnBottomBar: true,
  },
  {
    id: 'forms',
    labelKey: 'portal.nav.forms',
    iconName: 'ClipboardList',
    route: APPLICATION_ROUTES.clientPortalForms,
    showOnBottomBar: false,
  },
  {
    id: 'announcements',
    labelKey: 'portal.nav.announcements',
    iconName: 'Megaphone',
    route: APPLICATION_ROUTES.clientPortalAnnouncements,
    showOnBottomBar: false,
  },
  {
    id: 'account',
    labelKey: 'portal.nav.account',
    iconName: 'User',
    route: APPLICATION_ROUTES.clientPortalAccount,
    showOnBottomBar: true,
  },
];

export function filterClientNavigationItemsByEnabledModules(
  items: ClientNavigationItem[],
  enabledModules: string[]
): ClientNavigationItem[] {
  return items.filter(function keepEnabledItem(item) {
    if (item.requiredModule === undefined) {
      return true;
    }
    return enabledModules.includes(item.requiredModule);
  });
}

export function filterClientNavigationItemsForBottomBar(
  items: ClientNavigationItem[]
): ClientNavigationItem[] {
  return items.filter(function keepBottomBarItem(item) {
    return item.showOnBottomBar === true;
  });
}
